export enum ColumnsOptionsExecutedOrdersEnum {
	tickerCompany = 'tickerCompany',
	operation = 'operation',
	quantity = 'quantity',
	sum = 'sum',
	profitability = 'profitability',
	dateTime = 'dateTime',
}
